export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-factories-39ade1b656b86626b0dd394b3422a98a.jpg";